import { render } from "./role-grid-view.vue?vue&type=template&id=aaf4aea4&scoped=true"
import script from "./role-grid-view.vue?vue&type=script&setup=true&lang=js"
export * from "./role-grid-view.vue?vue&type=script&setup=true&lang=js"

import "./role-grid-view.vue?vue&type=style&index=0&id=aaf4aea4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaf4aea4"],['__file',"src/views/administration/roles/role-grid-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aaf4aea4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aaf4aea4', __exports__)) {
    api.reload('aaf4aea4', __exports__)
  }
  
  module.hot.accept("./role-grid-view.vue?vue&type=template&id=aaf4aea4&scoped=true", () => {
    api.rerender('aaf4aea4', render)
  })

}


export default __exports__